import React, { useContext, useEffect, useState } from 'react'
import SummaryApi from '../common'
import Context from '../context'
import displayINRCurrency from '../helpers/displayCurrency'
import { MdDelete } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ROLE from '../common/role';
import { useSelector } from 'react-redux';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import defaultImage from '../assest/DAWACO_Icon.png'; 
import MinimumBar from '../components/MinimumBar';
 import { HiOutlineGift } from 'react-icons/hi';

const Cart = () => {
    
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const context = useContext(Context);
    const navigate = useNavigate();
    const loadingCart = new Array(4).fill(null);
    const user = useSelector(state => state?.user?.user);
    const [barMinimum, setBarMinimum] = useState('');
    
    useEffect(() => {
        setLoading(true);
        const loadingTimeout = setTimeout(() => {
          
          setLoading(false);
          navigate("/");
        }, 10000); 
    
        if (user) {
          if (user?.role !== ROLE.GENERAL && user?.role !== ROLE.SALESMAN) {
          
            navigate("/");
            setLoading(false);
            
          } 
          else {
            setLoading(false);
            clearTimeout(loadingTimeout)
            handleLoading()
          }
        } 
    
        // Clear the timeout when the component unmounts or the effect is rerun
        return () => clearTimeout(loadingTimeout);
      }, [user, navigate]);




      const fetchBarMinimum= async () => {
        try {
            const response = await fetch(SummaryApi.getBarMinimum.url, {
                method: SummaryApi.getBarMinimum.method,
                credentials: 'include',
                headers: {
                    "Content-Type": 'application/json'
                }
            });
            const responseData = await response.json();
            setBarMinimum(responseData?.data);
        } catch (error) {
        }
    };

    const fetchData = async () => {
        const response = await fetch(SummaryApi.addToCartProductView.url, {
            method: SummaryApi.addToCartProductView.method,
            credentials: 'include',
            headers: {
                "content-type": 'application/json'
            },
            
        });

        const responseData = await response.json();

        if (responseData.success) {
            setData(responseData.data);
        }
        
    };

    const handleLoading = async () => {
        await fetchData();
        await fetchBarMinimum();

    };



    const increaseQty = async (id, qty) => {

        const targetProduct = data.find(product => product._id === id);
        
        if (qty < targetProduct.productDetails.quantity) {
        const response = await fetch(SummaryApi.updateCartProduct.url, {
            method: SummaryApi.updateCartProduct.method,
            credentials: 'include',
            headers: {
                "content-type": 'application/json'
            },
            body: JSON.stringify({
                _id: id,
                quantity: qty + 1
            })
        });

        const responseData = await response.json();

        if (responseData.success) {
            fetchData();
        }
    }
    else{
        
        toast.error(' المتاح حاليا بالمخزن"'+targetProduct.productDetails.productName+'" لقد وصلت للحد الاقصي من ');
    }
    };

    const decreaseQty = async (id, qty) => {
        if (qty >= 2) {
            const response = await fetch(SummaryApi.updateCartProduct.url, {
                method: SummaryApi.updateCartProduct.method,
                credentials: 'include',
                headers: {
                    "content-type": 'application/json'
                },
                body: JSON.stringify({
                    _id: id,
                    quantity: qty - 1
                })
            });

            const responseData = await response.json();

            if (responseData.success) {
                fetchData();
            }
        }
    };

    const deleteCartProduct = async (id) => {
        const response = await fetch(SummaryApi.deleteCartProduct.url, {
            method: SummaryApi.deleteCartProduct.method,
            credentials: 'include',
            headers: {
                "content-type": 'application/json'
            },
            body: JSON.stringify({
                _id: id,
            })
        });

        const responseData = await response.json();

        if (responseData.success) {
            fetchData();
            context.fetchUserAddToCart();
        }
    };

    const handlePayment = () => {
        if (data.length === 0) {
            toast.error('عربة التسوق الخاصة بك فارغة');
        } 
        else if(user?.role === ROLE.SALESMAN) {
            navigate('/payment-salesman');
        }
        else {
            navigate('/payment');
        }
    };

        const totalQty = data.reduce((previousValue, currentValue) => previousValue + currentValue.quantity, 0);
    
        const totalPrice = data.reduce((preve, curr) => {
            const price = curr.productDetails.sellingPrice > 0 ? curr.productDetails.sellingPrice : curr.productDetails.price;
            return preve + (curr.quantity * price);
        }, 0);
        



    if (loading) {
        return (
          <div className="flex justify-center items-center h-screen">
            <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
          </div>
        );
      }

    return (
        <div className='container mx-auto'>
            {barMinimum?.at(0)?.seq > totalPrice && (
                <MinimumBar />
            )}
            
            <div className='text-center text-lg my-3'>
                {
                    data.length === 0 && !loading && (
                        <p className='bg-white py-5'>لا يوجد منتجات</p>
                    )
                }
            </div>

            {errorMessage && (
                <div className='text-center text-red-600 mb-4'>
                    {errorMessage}
                </div>
            )}

            <div className='flex flex-col lg:flex-row gap-10 lg:justify-between p-4'>
                {/***view product */}
                <div className='w-full max-w-3xl'>
                    {
                        loading ? (
                            loadingCart?.map((el, index) => {
                                return (
                                    <div key={el + "Add To Cart Loading" + index} className='w-full bg-slate-200 h-32 my-2 border border-slate-300 animate-pulse rounded'>
                                    </div>
                                );
                            })
                        ) : (
                            data.map((product, index) => {
                                

                               
                               
                                const isIncreaseDisabled = (product?.quantity) >= product?.productDetails?.quantity;
                                var currPrice=product?.productDetails?.price
                                if(product?.productDetails?.sellingPrice>0){
                                currPrice = product?.productDetails?.sellingPrice;
                                }
                                return (
                                    <div key={product?._id + "Add To Cart Loading"} className='w-full bg-white h-50 my-2 border border-slate-300 rounded grid grid-cols-[128px,1fr]'>
                                        <div className='w-32 h-50 bg-slate-200'>
                                        <img src={product?.productDetails?.productImage[0] || defaultImage} className='w-full h-full object-scale-down mix-blend-multiply' />
                                        </div>
                                        <div className='px-4 py-2 relative'>
                                            {/**delete product */}
                                            <div className='absolute right-0 text-red-600 rounded-full p-2 hover:bg-red-600 hover:text-white cursor-pointer' onClick={() => deleteCartProduct(product?._id)}>
                                                <MdDelete />
                                            </div>

                                            <h2 className='text-lg lg:text-xl text-ellipsis line-clamp-1'>{product?.productDetails?.productName}</h2>
                                            <p className='capitalize text-slate-500'>{product?.productDetails?.category} {product?.productDetails?.bonusQuantity > 0 && product?.productDetails?.toBonus > 0 && product?.productDetails?.quantity && (
                                                <span className='absolute right text-green-600'>
                                                   <HiOutlineGift style={{ fontSize: '25px' }} />

                                                </span>
                                            )}</p>
                                            <div className='flex items-center justify-between'>
                                                <p className='text-blue-800 font-medium text-lg'>{displayINRCurrency(currPrice)}</p>
                                                <p className='text-slate-600 font-semibold text-lg'>{displayINRCurrency(currPrice * product?.quantity)}</p>
                                            </div>
                                            <div className='flex items-center gap-3 mt-1'>
                                                 <button
                                                    className='w-8 h-8 flex items-center justify-center border-2 border-blue-800 rounded-full text-gray-800'
                                                    onClick={() => decreaseQty(product._id,product.quantity)}   
                                                >
                                                    -
                                                </button>
                                                <span className='text-lg font-medium mx-10'>{product.quantity}</span>
                                                <button
                                                    className={`w-8 h-8 flex items-center justify-center border-2 border-blue-800 rounded-full text-gray-800 ${isIncreaseDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                                                    onClick={() => !isIncreaseDisabled && increaseQty(product._id,product.quantity)}   
                                                    disabled={isIncreaseDisabled} // Disable button when max quantity is reached
                                                >
                                                    +
                                                </button>
                                                
                                                </div>
                                                {product?.productDetails?.bonusQuantity> 0 && product?.productDetails?.toBonus > 0 && product?.quantity >= product?.productDetails?.toBonus &&(
                                                <span className='text-green-600 font-medium mx-10'>+ بونص {(Math.floor(product.quantity / product.productDetails?.toBonus)) * product?.productDetails?.bonusQuantity}</span>
                                                )}
                                        </div>
                                    </div>
                                );
                            })
                        )
                    }
                </div>

                {/***summary */}
                <div className='mt-5 lg:mt-0 w-full max-w-sm'>
                    {
                        loading ? (
                            <div className='h-36 bg-slate-200 border border-slate-300 animate-pulse'>
                            </div>
                        ) : (
                            <div className='h-36 bg-white text-center'>
                                <h2 className='text-white bg-blue-900 px-4 py-1'>ملخص الطلب</h2>
                                <div className='flex items-center justify-between px-4 gap-2 font-medium text-lg text-slate-600'>
                                    <p>{totalQty}</p>
                                    <p>الكمية</p>
                                    
                                </div>

                                <div className='flex items-center justify-between px-4 gap-2 font-medium text-lg text-slate-600'>
                                    <p>{displayINRCurrency(totalPrice)}</p>
                                    <p>السعر الاجمالى</p>
                                    
                                </div>

                                <button className={`bg-green-500 hover:bg-green-600 p-2 text-white w-full mt-2 ${ barMinimum?.at(0)?.seq > totalPrice ? 'opacity-50 cursor-not-allowed' : ''}`} disabled={barMinimum?.at(0)?.seq > totalPrice} onClick={handlePayment}>إتمام & مراجعة الطلب</button>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    );
};

export default Cart;
